<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">
        {{ $t('ITEM.EDIT') }} {{ $t('FILES.ITEM') }}
      </span>
    </v-card-title>
    <v-card-text>
      <div v-if="error">
        <v-alert
          v-for="(e, index) in error.data.errors"
          :key="index"
          color="error"
          dark
          dense
          >{{ e[0] }}</v-alert
        >
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="documentModified.title"
          :counter="255"
          :rules="rules.requiredTextLine"
          :label="`${$t('ITEM.TITLE')} *`"
        ></v-text-field>

        <v-select
          v-model="documentModified.type_id"
          :loading="!!!types.length"
          :items="types"
          item-text="text"
          item-value="id"
          :rules="rules.requiredSelectNotArray"
          :label="`${$t('ITEM.TYPE')} *`"
        ></v-select>

        <div class="container">
          <div class="large-12 medium-12 small-12 cell">
            <autoupload-file-input
              v-model="upload"
              :label="$t('DOCUMENTS.FILE')"
              :url="`uploads/documents`"
              @input="documentModified.upload_id = $event"
            ></autoupload-file-input>
          </div>
        </div>

        <v-container>
          <v-layout align-center justify-space-between row>
            <v-btn outlined text @click="$emit('cancel')">{{
              $t('BUTTON.CANCEL')
            }}</v-btn>

            <v-btn
              color="success"
              :disabled="!valid"
              :loading="loading"
              @click="validate"
              >{{ $t('BUTTON.UPDATE') }}</v-btn
            >
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  requiredTextLine,
  requiredSelectNotArray
} from '@/modules/_global/variables/rules.js';
import AutouploadFileInput from '@/modules/_global/_components/AutouploadFileInput';
import { mapActions } from 'vuex';

export default {
  name: 'DocumentsEdit',

  components: {
    AutouploadFileInput
  },

  props: {
    document: {
      type: Object,
      required: true
    },
    person: {
      type: Object,
      default: () => {}
    }
  },

  data: () => ({
    documentModified: {
      id: '',
      title: '',
      type_id: ''
    },
    upload: undefined,
    types: [],
    error: null,
    file: '',
    valid: true,
    rules: {
      requiredTextLine,
      requiredSelectNotArray
    }
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    }
  },

  created() {
    this.documentModified.id = this.document.id;
    this.documentModified.title = this.document.title;
    this.documentModified.type_id = this.document.type_id;

    this.upload = {
      ...this.document,
      id: this.document.upload_id
    };

    var getTypes = 'document/retrieveTypes';

    if (this.person) getTypes = 'document/retrieveTypesAdministrative';

    this.$store.dispatch(getTypes).then(({ data }) => {
      data.forEach(type => {
        type.text = this.$t('DOCUMENTS.' + type.title.toUpperCase());
      });
      this.types = data;
    });
  },

  methods: {
    ...mapActions('document', ['updateDocument', 'addDocumentForPerson']),
    validate() {
      if (this.$refs.form.validate()) {
        this.updateDocument({
          documentId: this.documentModified.id,
          document: this.documentModified
        })
          .then(({ data }) => {
            this.$emit('success', data);
          })
          .catch(error => {
            this.error = error.response;
          });
      }
    }
  }
};
</script>
